import React, { useEffect, useState } from 'react';
import Pagination from 'react-bootstrap/Pagination';
import PageItem from 'react-bootstrap/PageItem'

const Paginations = ({ current_page = 1, total_page = 1, per_page = 1, changePage, showAlways = 1 }) => {
    let active = parseInt(current_page);
    total_page = Math.ceil(total_page / per_page);
    let items = [];
    
    if(active > 1) items.push(<Pagination.Prev key="prev" onClick={(e)=>changePage(active - 1)} />);

    /**
     * Will display pagination item(s) even for one (1) page
     */
    if(showAlways){
        for (let number = 1; number <= total_page; number++) {
            if(number == active){ //Current Page
                items.push(<PageItem key={number} active={number === active}>{number}</PageItem>);
            }else{
                items.push(<PageItem key={number} active={number === active} onClick={(e)=>changePage(number)}>{number}</PageItem>);
            }
        }
    }
    
    if(active < total_page) items.push(<Pagination.Next key="next" onClick={(e)=>changePage(active + 1)} />)

    return (
        // outputs(current_page, total_page, per_page)
        <Pagination className='d-flex justify-content-center'>
            {items}
        </Pagination>
    );
}

export default Paginations;